/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "1",
    spendId: "26",
    unit: "USD",
    title: "Số tiền kết dư của phần dầu thô, condensate, khí thiên nhiên (nếu có) để lại",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "2",
    spendId: "27",
    unit: "USD",
    title: "Số tiền kết dư của phần khí thiên nhiên để lại (nếu có)",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "3",
    spendId: "28",
    title: "Số tiền kết dư của phần dầu thô, condensate để lại [28]=[26]-[27]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "4",
    spendId: "29",
    unit: "USD/thùng",
    title: "Giá bình quân gia quyền của các lô dầu thô, condensate xuất bán trong kỳ kết dư",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "5",
    spendId: "30",
    unit: "Thùng",
    title: "Sản lượng dầu lãi từ tiền kết dư của phần dầu để lại [30] = [28]/[29]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "6",
    spendId: "31",
    unit: "USD/thùng",
    title: "Giá dầu thô cơ sở",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "7",
    spendId: "32",
    unit: "USD",
    title: "Số phụ thu tạm tính phải nộp [32]=[33] hoặc [34]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "7.1",
    spendId: "33",
    unit: "USD",
    title: "Trường hợp {1,2x[31] < [29] <= {1,5x[31]}: [33] = 50%x{[29]-1,2x[31]}x[30]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "7.2",
    spendId: "34",
    unit: "USD",
    title: "Trường hợp [29] > {1,5x[31]}: [34]=[35] + [36]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "a",
    spendId: "35",
    unit: "USD",
    title: "- Phụ thu theo mức 50% [35] = 50%x{1,5x[31]-1,2x[31]}x[30]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "b",
    spendId: "36",
    unit: "USD",
    title: "- Phụ thu theo mức 60% [36] = 60%x{[29]-1,5x[31]}x[30]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "8",
    spendId: "37",
    unit: "VND/USD",
    title: "Tỷ giá quy đổi",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (spendId) =>
    ["28", "30", "32", "33", "34", "35", "36"].includes(spendId) || !spendId;

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá trị
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: 800,
                  }}
                >
                  {item.spendId ? `[${item.spendId}]` : ""}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.unit}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {isDisabled(item.spendId) ? (
                    "0,00"
                  ) : (
                    <InputTable
                      id={item.id}
                      value={item.value5}
                      name="value5"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
